var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_1306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19.4993V12",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.4997V11.9863",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5H20.9999",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.375C17.25 9.83578 17.1287 10.2884 16.8983 10.6875C16.6679 11.0865 16.3365 11.4179 15.9375 11.6483C15.5384 11.8787 15.0858 12 14.625 12C14.1642 12 13.7115 11.8787 13.3125 11.6483C12.9134 11.4179 12.5821 11.0865 12.3517 10.6875C12.1213 10.2884 12 9.83578 12 9.375",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9.375C22.5 9.83578 22.3787 10.2884 22.1483 10.6875C21.9179 11.0865 21.5865 11.4179 21.1875 11.6483C20.7884 11.8787 20.3358 12 19.875 12C19.4142 12 18.9615 11.8787 18.5625 11.6483C18.1634 11.4179 17.8321 11.0865 17.6017 10.6875C17.3713 10.2884 17.25 9.83578 17.25 9.375",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74996 9.375C6.74996 9.83578 6.62867 10.2884 6.39828 10.6875C6.16789 11.0865 5.83652 11.4179 5.43747 11.6483C5.03843 11.8787 4.58576 12 4.12498 12C3.6642 12 3.21154 11.8787 2.81249 11.6483C2.41344 11.4179 2.08207 11.0865 1.85168 10.6875C1.62129 10.2884 1.5 9.83578 1.5 9.375",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.375C12 9.83578 11.8787 10.2884 11.6483 10.6875C11.4179 11.0865 11.0865 11.4179 10.6875 11.6483C10.2884 11.8787 9.83576 12 9.37498 12C8.9142 12 8.46154 11.8787 8.06249 11.6483C7.66344 11.4179 7.33207 11.0865 7.10168 10.6875C6.87129 10.2884 6.75 9.83578 6.75 9.375",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.37517L2.99999 1.5",
    stroke: "#585858",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 1.5L22.5 9.37495",
    stroke: "#585858",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.37503L16.5 1.5",
    stroke: "#585858",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.37499L7.49999 1.5",
    stroke: "#585858",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.37502V1.5",
    stroke: "#585858",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18H20.9999",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22.5H16.4999",
    stroke: "#585858",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5C19.5 20.2956 19.1839 21.0587 18.6213 21.6213C18.0587 22.1839 17.2956 22.5 16.5 22.5",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50002 19.5C4.50002 20.2956 4.81609 21.0587 5.37869 21.6213C5.9413 22.1839 6.70436 22.5 7.5 22.5",
    stroke: "#585858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_1306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.d678724fe20173e70f31640496ff7adf.svg";
export { ForwardRef as ReactComponent };